import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_LOCAL_CANCEL_FEE_TRANSFER_REJECT_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION =
	graphql(/* GraphQL */ `
		mutation ReservationLocalCancelFeeTransferRejectForManagementReservationItemDetailUpdate(
			$input: ReservationLocalCancelFeeRejectInput!
		) {
			reservationLocalCancelFeeTransferReject(input: $input) {
				reservationDetail {
					canHandleLocalPaymentCancelFee
					canUpdate
					statusReservation
					localCancelFeeTransferDate
					localCancelFeeTransferAccountName
					# 拒否で rejectReason / lackPrice が書き換わる。入れ子のためキャッシュ更新で丸ごと置き換わるので、
					# 予約詳細クエリ（RESERVATION_DETAIL_FOR_MANAGEMENT_RESERVATION_ITEM_QUERY）と同じ選択にしておくこと
					localCancelFeeTransferInfo {
						lackPrice
						rejectReason
						transferAccountName
						transferDate
					}
				}
				userErrors
			}
		}
	`);
